module.exports = __webpack_public_path__ + "static/media/nutritionistDashIcon.bf8287d1.png";